import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import { Navigation } from "./Components/navigation";
import { Header } from "./Components/header";
import { Stats } from "./Components/stats";
import { Features } from "./Components/features";
import { Services } from "./Components/services";
import { Portfolio } from "./Components/portfolio";
import { Clients } from "./Components/clients";
import { Process } from "./Components/process";
import { About } from "./Components/about";
import { Team } from "./Components/Team";
import { Testimonials } from "./Components/testimonials";
import { Contact } from "./Components/contact";
import ScrollToTop from "./Components/scrolltotop";
import { Footer } from "./Components/foorter";
import PrivacyPolicy from "./Components/privacypolicy";
import TermsConditions from "./Components/termsconditions";

// Scroll to top whenever the route changes
const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => {
  // Scroll reveal — re-observes as nodes appear
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("reveal--in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <Navigation />
      <Header />
      <Stats />
      <Features />
      <Services />
      <Portfolio />
      <Clients />
      <Process />
      <About />
      <Team />
      <Testimonials />
      <Contact />
      <Footer />
      <ScrollToTop />
    </>
  );
};

const App = () => {
  // Cursor-follow glow for .glow-card elements
  useEffect(() => {
    const onMove = (e) => {
      const card = e.target.closest?.(".glow-card");
      if (!card) return;
      const r = card.getBoundingClientRect();
      card.style.setProperty("--mx", `${e.clientX - r.left}px`);
      card.style.setProperty("--my", `${e.clientY - r.top}px`);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  return (
    <BrowserRouter>
      <div className="bg-[#05070f]">
        <ScrollToTopOnRouteChange />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
};

export default App;
